import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { useCountry } from '../contexts/CountryContext';

const AI_DISCLAIMER_BY_COUNTRY = {
  UK: 'Always obtain a RICS-certified valuation before proceeding.',
  IN: 'Always obtain a valuation from a RERA-approved or government-registered valuer before proceeding.',
  CA: 'Always obtain a valuation from a certified appraiser (AIC-designated) before proceeding.',
};

const AIDisclaimer = ({ compact = false }) => {
  const { country } = useCountry();
  const countryNote = AI_DISCLAIMER_BY_COUNTRY[country] || AI_DISCLAIMER_BY_COUNTRY.UK;

  if (compact) {
    return (
      <p className="text-[10px] text-amber-600 flex items-center gap-1 mt-2" data-testid="ai-disclaimer-compact">
        <AlertTriangle className="h-3 w-3 flex-shrink-0" />
        <span>AI guidance only — not a professional valuation. {countryNote}</span>
      </p>
    );
  }

  return (
    <div className="bg-amber-50 border border-amber-200 p-3 mt-3 flex items-start gap-2" data-testid="ai-disclaimer">
      <AlertTriangle className="h-4 w-4 text-amber-500 flex-shrink-0 mt-0.5" />
      <div>
        <p className="text-xs text-amber-700 font-medium">AI Guidance Disclaimer</p>
        <p className="text-[11px] text-amber-600 mt-0.5 leading-relaxed">
          This AI-generated insight is for indicative guidance only. It does not constitute a professional valuation, survey, or financial advice. {countryNote}
        </p>
      </div>
    </div>
  );
};

export default AIDisclaimer;
